import * as actions from './actions';
import * as reducers from './reducers';
import * as selectors from './selectors';

const nextgen = { actions, reducers, selectors };
export default nextgen;
